(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-portrait-styles"] && !Shopify.designMode) return;
  try {
    

function initializePortraits(scope) {
 const roots=scope.matches?.('[data-av-portraits]')?[scope]:scope.querySelectorAll('[data-av-portraits]');
 for(const root of roots){
  if(root.dataset.initialized)continue;
  root.dataset.initialized='true';
  const controller=new AbortController(),on=(el,event,handler)=>el.addEventListener(event,handler,{signal:controller.signal});
  const tabs=[...root.querySelectorAll('[data-direction-tab]')],panels=[...root.querySelectorAll('.av-direction-panel')];
  const core=root.querySelector('.av-core'),shell=root.querySelector('.av-comparison-shell'),controls=root.querySelector('.av-style-controls'),tablist=root.querySelector('.av-comparison-tabs'),examples=root.querySelector('.av-direction-panels');
  const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let directionIndex=0,compact=false,styleFrame,styleWidth=0;
  const navigationHeight=()=>parseFloat(getComputedStyle(controls).getPropertyValue('--av-style-height'))||120;
  const headerOffset=()=>parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--av-header-offset'))||0;
  function revealTab(index,instant=false){
   if(!compact)return;
   const item=tabs[index].getBoundingClientRect(),strip=tablist.getBoundingClientRect();
   if(item.left<strip.left||item.right>strip.right)tablist.scrollTo({left:tabs[index].offsetLeft-tablist.offsetLeft-(tablist.clientWidth-tabs[index].offsetWidth)/2,behavior:instant||reduced()?'instant':'smooth'});
  }
  function measureStyles(){
   const wasCompact=compact;
   controls.classList.remove('is-compact','is-past');
   shell.style.height='';
   shell.style.height=controls.getBoundingClientRect().height+'px';
   const rect=shell.getBoundingClientRect();
   controls.style.setProperty('--av-style-left',rect.left+'px');
   controls.style.setProperty('--av-style-width',rect.width+'px');
   styleWidth=rect.width;
   controls.classList.toggle('is-compact',wasCompact);
   updateStyles();
  }
  function updateStyles(){
   const top=headerOffset(),bounds=shell.getBoundingClientRect(),height=navigationHeight();
   const next=bounds.bottom<=top+height;
   if(next!==compact){
    compact=next;
    controls.classList.toggle('is-compact',compact);
    if(compact){
     panels.forEach(panel=>panel.querySelectorAll('img').forEach(img=>img.loading='eager'));
     revealTab(directionIndex,true);
     if(!reduced())tabs.forEach(tab=>tab.querySelector('img').animate([{transform:'translateY(-12px) scale(1.3)',opacity:.55},{transform:'translateY(0) scale(1)',opacity:1}],{duration:260,easing:'cubic-bezier(.2,.7,.2,1)'}));
    }else tablist.scrollLeft=0;
   }
   const end=core.getBoundingClientRect().bottom;
   controls.classList.toggle('is-past',compact&&end<=top);
   controls.style.setProperty('--av-style-top',Math.min(top,end-height)+'px');
  }
  function queueStyles(){cancelAnimationFrame(styleFrame);styleFrame=requestAnimationFrame(updateStyles);}
  function selectDirection(index,{focus=false,scroll=false}={}){
   const next=(index+tabs.length)%tabs.length;
   const update=()=>{
    directionIndex=next;
    tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===next));tab.tabIndex=i===next?0:-1;panels[i].hidden=i!==next;});
    panels[next].querySelectorAll('img').forEach(img=>img.loading='eager');
    root.querySelector('[data-style-count]').textContent=String(next+1).padStart(2,'0')+' / 04';
    root.querySelector('[data-style-status]').textContent=tabs[next].querySelector('.av-comparison-title').textContent;
   };
   update();
   if(focus)tabs[next].focus({preventScroll:true});
   revealTab(next);
   if(scroll&&!compact)window.scrollTo({top:examples.getBoundingClientRect().top+window.scrollY-navigationHeight()-20,behavior:reduced()?'instant':'smooth'});
  }
  tabs.forEach((tab,i)=>{
   on(tab,'click',()=>selectDirection(i,{scroll:true}));
   on(tab,'keydown',event=>{
    let next;
    if(event.key==='ArrowRight')next=(i+1)%tabs.length;
    if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;
    if(event.key==='Home')next=0;
    if(event.key==='End')next=tabs.length-1;
    if(next!==undefined){event.preventDefault();selectDirection(next,{focus:true});}
   });
  });
  root.querySelectorAll('[data-style-step]').forEach(button=>on(button,'click',()=>selectDirection(directionIndex+Number(button.dataset.styleStep))));
  on(window,'scroll',queueStyles);
  on(window,'resize',measureStyles);
  const styleObserver=new ResizeObserver(()=>{if(Math.abs(shell.getBoundingClientRect().width-styleWidth)>1)measureStyles();});
  styleObserver.observe(shell);
  document.fonts.ready.then(()=>{if(root.isConnected)measureStyles();});
  measureStyles();
  const track=root.querySelector('#av-discovery-track'),slides=[...track.querySelectorAll('[data-slide]')],thumbs=[...root.querySelectorAll('[data-example]')];
  let galleryIndex=0,resizeFrame,scrollTimer;
  const position=index=>slides[index].getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft;
  function updateGallery(index,announce=true){
   galleryIndex=index;root.querySelector('#av-gallery-count').textContent=String(index+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
   thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.example===slides[index].dataset.slide)));
   if(announce)root.querySelector('#av-discovery-status').textContent=slides[index].getAttribute('aria-label');
  }
  function go(index,instant=false){
   const next=(index+slides.length)%slides.length,wrap=Math.abs(next-galleryIndex)>1;
   updateGallery(next);track.scrollTo({left:position(next),behavior:instant||wrap||reduced()?'instant':'smooth'});
  }
  on(document,'keydown',event=>{
   if(event.defaultPrevented||event.altKey||event.ctrlKey||event.metaKey||event.shiftKey)return;
   const target=event.target;
   if(target.closest('input,textarea,select,[contenteditable]:not([contenteditable="false"]),[role="textbox"],[role="combobox"],dialog,[role="dialog"]')||document.querySelector('dialog[open],.mobile-menu[open]'))return;
   const step=event.key==='ArrowRight'||event.code==='Numpad6'?1:event.key==='ArrowLeft'||event.code==='Numpad4'?-1:0;
   if(!step)return;
   const visibleHeight=element=>{const rect=element.getBoundingClientRect();return Math.max(0,Math.min(rect.bottom,window.innerHeight)-Math.max(rect.top,headerOffset()+navigationHeight()));};
   const mainVisible=compact&&!controls.classList.contains('is-past')?visibleHeight(examples):0;
   const galleryVisible=visibleHeight(track);
   if(Math.max(mainVisible,galleryVisible)<60)return;
   event.preventDefault();
   if(galleryVisible>mainVisible)go(galleryIndex+step);
   else selectDirection(directionIndex+step,{focus:tablist.contains(target)});
  });
  thumbs.forEach(b=>on(b,'click',()=>go(slides.findIndex(s=>s.dataset.slide===b.dataset.example))));
  root.querySelectorAll('[data-gallery-step]').forEach(b=>on(b,'click',()=>go(galleryIndex+Number(b.dataset.galleryStep))));
  on(track,'keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(galleryIndex+(event.key==='ArrowRight'?1:-1));}if(event.key==='Home'||event.key==='End'){event.preventDefault();go(event.key==='Home'?0:slides.length-1);}});
  on(track,'scroll',()=>{clearTimeout(scrollTimer);scrollTimer=setTimeout(()=>{const index=slides.reduce((best,s,i)=>Math.abs(position(i)-track.scrollLeft)<Math.abs(position(best)-track.scrollLeft)?i:best,0);updateGallery(index);},140);});
  const observer=new ResizeObserver(()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(()=>{track.scrollTo({left:position(galleryIndex),behavior:'instant'});});});observer.observe(track);
  on(document,'shopify:section:unload',event=>{if(!event.target.contains(root))return;observer.disconnect();styleObserver.disconnect();cancelAnimationFrame(styleFrame);clearTimeout(scrollTimer);cancelAnimationFrame(resizeFrame);controller.abort();});
  updateGallery(0,false);
 }
}
initializePortraits(document);
document.addEventListener('shopify:section:load',event=>initializePortraits(event.target));



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-process"] && !Shopify.designMode) return;
  try {
    

function initializePortraitThread(scope) {
  for (const journey of scope.querySelectorAll('[data-avp-journey]')) {
    if (journey.dataset.threadReady) continue;
    journey.dataset.threadReady = 'true';
    const svg = journey.querySelector('[data-avp-thread]');
    const path = svg.querySelector('path');
    const markers = [...journey.querySelectorAll('.avp-step-number')];
    let frame;
    const draw = () => {
      const bounds = journey.getBoundingClientRect();
      const points = markers.map(marker => {
        const box = marker.getBoundingClientRect();
        return [box.left - bounds.left + box.width / 2, box.top - bounds.top + box.height / 2];
      });
      svg.setAttribute('viewBox', '0 0 ' + bounds.width + ' ' + bounds.height);
      path.setAttribute('d', points.map((point, index) => (index ? 'L' : 'M') + point.join(' ')).join(' '));
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(draw);
    };
    const observer = new ResizeObserver(schedule);
    observer.observe(journey);
    for (const marker of markers) observer.observe(marker);
    if (document.fonts) document.fonts.ready.then(schedule);
    schedule();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(journey)) {
        observer.disconnect();
        cancelAnimationFrame(frame);
      }
    });
  }
}
initializePortraitThread(document);
document.addEventListener('shopify:section:load', event => initializePortraitThread(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-list"] && !Shopify.designMode) return;
  try {
    

for(const root of document.querySelectorAll('[data-journal]')){
 if(root.dataset.ready)continue;root.dataset.ready='true';
 const grid=root.querySelector('[data-j-entries]'),buttons=[...root.querySelectorAll('[data-j-topic]')],copy=JSON.parse(root.querySelector('[data-j-copy]').textContent),key='av-journal-topic-v1';
 const allowed=buttons.map(b=>b.dataset.jTopic);let topic='all';
 const fromURL=()=>new URL(location.href).searchParams.get('topic');
 const cards=()=>[...grid.querySelectorAll('[data-j-category]')];
 const sort=()=>{for(const card of cards().sort((a,b)=>Number(a.dataset.jRank)-Number(b.dataset.jRank)))grid.append(card)};
 function apply(next,save=true){
  topic=allowed.includes(next)?next:'all';root.dataset.topic=topic;
  let count=0;for(const card of cards()){card.hidden=topic!=='all'&&card.dataset.jCategory!==topic;if(!card.hidden)count++}
  for(const button of buttons)button.setAttribute('aria-pressed',String(button.dataset.jTopic===topic));
  root.querySelector('[data-j-description]').textContent=copy[topic.replaceAll('-','_')+'_description'];
  root.querySelector('[data-j-count]').textContent=count===1?copy.count_one:String(count)+' '+copy.count_many;
  root.querySelector('[data-j-empty]').hidden=count!==0;
  root.querySelector('[data-j-fiction-note]').hidden=!cards().some(c=>!c.hidden&&c.querySelector('.j-fiction'));
  if(save){const url=new URL(location.href);url.searchParams.set('topic',topic);url.searchParams.delete('page');history.replaceState(null,'',url);try{sessionStorage.setItem(key,topic)}catch{}}
 }
 for(const button of buttons)button.addEventListener('click',()=>apply(button.dataset.jTopic));
 sort();let initial=fromURL();if(!initial){try{initial=sessionStorage.getItem(key)}catch{}}apply(initial||'all',false);
 window.addEventListener('popstate',()=>apply(fromURL()||'all',false));
 async function collect(){
  let next=Number(grid.dataset.jPage)>1?grid.dataset.jFirst:grid.dataset.jNext;
  if(!next)return;
  grid.setAttribute('aria-busy','true');root.querySelector('[data-j-count]').textContent=copy.loading;
  try{
   const seen=new Set(cards().map(c=>c.dataset.jId)),visited=new Set();
   while(next){
    const url=new URL(next,location.href);url.searchParams.set('section_id',root.closest('.shopify-section').id.replace('shopify-section-',''));
    if(url.origin!==location.origin||visited.has(url.href))throw new Error('Invalid pagination');visited.add(url.href);
    const response=await fetch(url);if(!response.ok)throw new Error('Collection unavailable');
    const page=new DOMParser().parseFromString(await response.text(),'text/html'),incoming=page.querySelector('[data-j-entries]');if(!incoming)throw new Error('Collection unavailable');
    for(const card of incoming.querySelectorAll('[data-j-category]'))if(!seen.has(card.dataset.jId)){seen.add(card.dataset.jId);grid.append(document.importNode(card,true))}
    next=incoming.dataset.jNext;
   }
   sort();apply(topic);const pagination=root.querySelector('[data-j-pagination]');if(pagination)pagination.hidden=true;
  }catch{root.querySelector('[data-j-load-error]').hidden=false;apply(topic,false)}finally{grid.setAttribute('aria-busy','false')}
 }
 collect();
}


  } catch(e) { console.error(e); }
})();
})();
